import React, {createContext, useReducer} from 'react'

export const SET_GRAPH_MISSING_IMAGES_LIST = 'SET_GRAPH_MISSING_IMAGES_LIST'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_GRAPH_MISSING_IMAGES_LIST:
      return { ...data, list: payload.data }
    default:
      return data
  }
}

const initialState = {
  list: [],
}

const GraphMissingImagesStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <GraphMissingImagesContext.Provider value={[state, dispatch]}>
      {children}
    </GraphMissingImagesContext.Provider>
  )
}

export const GraphMissingImagesContext = createContext(initialState)
export default GraphMissingImagesStore
